import instance from "../xhrService";

export const inspectionQuestionApi = {
  show: (id: number) =>
    instance
      .get(`/api/inspections/${id}/questions`)
      .then(response => response.data),
};
